<template>
    <div>
        <DashboardLayoutComponent
            :key="reportData"
            @on-set-current-sidebar="onSetCurrentSidebar($event)"
        >
            <div v-show="!isLoading">
                <!-- <div class="overflow-x-hidden" style="height: 596px !important;"> -->
                <div style="height: 596px !important; mt-6">
                    <DataCharts
                        :is-loading="isLoadingDataChart"
                        :analytics-data="reportData"
                    />
                </div>
            </div>
            <div v-show="isLoading" class="custom-report-table mt-10">
                <PlaceholderComponent
                    type="table"
                    items="1"
                />
            </div>
        </DashboardLayoutComponent>
    </div>
</template>

<script>
import DashboardLayoutComponent from "@Layouts/dashboard/";
import { onMounted, onUpdated, ref } from "vue";
import useSections from "@Functions/useSections.js";
import useReport from "@Functions/useReport.js";
import useMenuNav from "@Functions/useMenuNav.js";
import DataCharts from "@DataChartsModule/module";
import { PlaceholderComponent } from "@CommonComponents";
export default {
    name: "GenerateModule",
    components: {
        DashboardLayoutComponent,
        DataCharts,
        PlaceholderComponent
    },
    setup() {
        const isLoading = ref(false);
        const {
            onNavChanged,
            onSetCurrentSidebar,
        } = useSections();
        const {
            menuNavRedirect,
            menuNav,
            onMenuNavTypeChange
        } = useMenuNav();

        const { queryBuild, reportData, isLoadingDataChart } = useReport();

        onUpdated(() => {
            reportData
        })

        onMounted(() => {
            isLoading.value = true;
            queryBuild(window.location.pathname.replace('/generate/template/', '')).then(() => {
                isLoading.value = false;
            })
        });
        return {
            isLoading,
            onNavChanged,
            onSetCurrentSidebar,
            menuNavRedirect,
            menuNav,
            onMenuNavTypeChange,
            reportData,
            isLoadingDataChart
        };
    },
};
</script>

<style lang="scss">
.initial-generate-module {
    .initial-landing {
        @apply border border-gray-200 rounded-lg shadow-sm divide-gray-200 bg-white ml-6 mt-6;
        align-content: start;
        .initial-landing {
            &__wrapper {
                @apply flex items-center p-3 border-b;
            }
            &__icon {
                @apply h-6 w-6 mt-4 ml-4 text-gray-400;
            }
            &__list {
                @apply p-3;
                &.empty-state-component {
                    @apply md:col-span-2;
                }
            }
        }
    }
    .spinner-component {
        @apply flex items-center justify-center;
        min-height: 67vh;
    }
}
.custom-report-table {
    .chart-placeholder__box {
        min-height: 500px !important;
    }
}
</style>
